import { AdSlotTargetingArguments } from '../global/adSlot/AdSlot';
import { useSelector } from 'react-redux';
import { DeviceType, WholeState } from '../../store/common/type';
import {
  buildIsTest,
  getAdPlatformType,
} from '../../common/helpers/ads/AdsHelper';

export function useAdTargetingArguments(
  sect: string | string[],
  subsect?: string,
): AdSlotTargetingArguments {
  const deviceType = useSelector<WholeState, DeviceType>((state) =>
    state.common !== undefined ? state.common.deviceType : 'desktop',
  );

  const adPlatform = getAdPlatformType(deviceType);

  return {
    lang: 'th',
    url: global.origin ?? '',
    platform: adPlatform,
    sect,
    subsect,
    ...(buildIsTest() as { isTest: 'yes' } | Record<string, never>),
  };
}
